const baseConfig = {
  serverUrl: process.env.REACT_APP_API_ROOT,
  marketplaceUrl: process.env.REACT_APP_MARKETPLACE_URL,
};

export default baseConfig;
